function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Beaker"
}, /*#__PURE__*/React.createElement("path", {
  id: "BG",
  d: "M0 20C0 8.95431 8.9543 0 20 0H48V40H20C8.95431 40 0 31.0457 0 20Z",
  fill: "#9EE4F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M34.75 25.2287L29.7143 17.7252V11.4857C30.0839 11.4857 30.3839 11.1977 30.3839 10.8428C30.3839 10.488 30.0839 10.2 29.7143 10.2H24.3571C23.9875 10.2 23.6875 10.488 23.6875 10.8428C23.6875 11.1977 23.9875 11.4857 24.3571 11.4857V17.7252L19.3221 25.228C19.1118 25.5417 19 25.9024 19 26.2714C19 27.3347 19.9013 28.2 21.0089 28.2H33.0625C34.1701 28.2 35.0714 27.3347 35.0714 26.2714C35.0714 25.9024 34.9596 25.5417 34.75 25.2287ZM25.59 18.2627C25.6596 18.1585 25.6964 18.0377 25.6964 17.9142V11.4857H28.375V17.9142C28.375 18.0377 28.4118 18.1585 28.4815 18.2627L29.9734 20.4857H24.098L25.59 18.2627ZM29.648 22.1828C29.648 21.828 29.948 21.54 30.3176 21.54C30.6873 21.54 30.9873 21.828 30.9873 22.1828C30.9873 22.5377 30.6873 22.8257 30.3176 22.8257C29.948 22.8257 29.648 22.5377 29.648 22.1828ZM32.5951 25.5765C32.2844 25.7687 31.8699 25.6825 31.6696 25.3842L30.6866 23.9198C30.4864 23.6215 30.5761 23.2236 30.8868 23.0314C31.1975 22.8392 31.6121 22.9253 31.8123 23.2236L32.7953 24.688C32.9955 24.9863 32.9065 25.3842 32.5951 25.5765Z",
  fill: "#008BAD"
}));

function SvgIconBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeaker);
export default __webpack_public_path__ + "static/media/icon_beaker.c67fa749.svg";
export { ForwardRef as ReactComponent };